var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"outline-warning","size":"sm","disabled":_vm.loading},on:{"click":_vm.resend}},[(_vm.loading)?_c('b-spinner',{staticClass:"mr-1",attrs:{"small":""}}):_vm._e(),_vm._v(" "+_vm._s(_vm.loading ? "Resending..." : "Resend")+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }